var React = require('react');

var Tabs = require('react-bootstrap/lib/Tabs');
var Tab = require('react-bootstrap/lib/Tab');
var Form = require('react-bootstrap/lib/Form');
var FormControl = require('react-bootstrap/lib/FormControl');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');
var FormGroup = require('react-bootstrap/lib/FormGroup');
var Button = require('react-bootstrap/lib/Button');

require('./SignUp.css');

var style = {
	container: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		height: '100%',
		margin: '0 25%'
	}
};

var SignUp = React.createClass({
	
	getInitialState: function() {
		return {
			timestamp: Date.now(),
			name: null,
			email: null,
			phone: null,
			cpf: null,
			cnpj: null,
			address: null,
			city: null,
			state: null,
			nickname: null,
			pass: null,
			fgtype: 0
		}
	},
	
	clearForm: function() {
		return this.setState({ 
			timestamp: Date.now(), 
			name: null,
			email: null,
			phone: null,
			cpf: null,
			cnpj: null,
			address: null,
			city: null,
			state: null,
			nickname: null,
			pass: null
		});
	},

	signUp: function(userData) {
		this.props.signUp(userData);
	},

	onSubmit (e) {
	    var me = this, state = me.state,
	    	data = {
	    		name: state.name,
	    		email: state.email,
	    		phone: state.phone,
	    		pass: state.pass,
	    		fgtype: state.fgtype,
	    		cpf: state.cpf,
	    		cnpj: state.cnpj,
	    		address: state.address,
				city: state.city,
				state: state.state,
				nickname: state.nickname,
	    	};

	    e.preventDefault();

	    me.signUp(data);

	    me.clearForm();
	},

	onFieldChanged (e) {
	    this.setState({[e.target.name]: e.target.value})
	},

	handleType: function(type) {
		var me = this;

		me.clearForm();

		this.setState({ fgtype: type });
	},

	getForm: function(fgType) {
		var me = this;

		if (fgType === 0) {
			return (
				<Form onChange={me.onFieldChanged} key={me.state.timestamp}>
					<FormGroup  controlId="formName">
						<ControlLabel>Nome</ControlLabel>
						<FormControl name="name" type="text" placeholder="Nome"/>
					</FormGroup>

					<FormGroup  controlId="formEmail">
						<ControlLabel>Email</ControlLabel>
						<FormControl name="email" type="email" placeholder="Email"/>
					</FormGroup>

					<FormGroup  controlId="formCPF">
						<ControlLabel>CPF</ControlLabel>
						<FormControl name="cpf" type="number" placeholder="CPF"/>
					</FormGroup>

					<FormGroup  controlId="formPhone">
						<ControlLabel>Telefone</ControlLabel>
						<FormControl name="phone" type="number" placeholder="Telefone"/>
					</FormGroup>

					<FormGroup  controlId="formPassword">
						<ControlLabel>Password</ControlLabel>
						<FormControl name="pass" type="password" placeholder="Password"/>
					</FormGroup>

					<FormGroup>
						<Button type="submit" onClick={me.onSubmit} block bsStyle="primary">
							Registrar
						</Button>
					</FormGroup>
				</Form>
			)
		} else {
			return (
				<Form onChange={me.onFieldChanged} key={me.state.timestamp}>
					<FormGroup  controlId="formName">
						<ControlLabel>Nome</ControlLabel>
						<FormControl name="name" type="text" placeholder="Nome"/>
					</FormGroup>

					<FormGroup  controlId="formEmail">
						<ControlLabel>Email</ControlLabel>
						<FormControl name="email" type="email" placeholder="Email"/>
					</FormGroup>

					<FormGroup  controlId="formCNPJ">
						<ControlLabel>CNPJ</ControlLabel>
						<FormControl name="cnpj" type="number" placeholder="CNPJ"/>
					</FormGroup>

					<FormGroup  controlId="formAddress">
						<ControlLabel>Endereço</ControlLabel>
						<FormControl name="address" type="text" placeholder="Endereço"/>
					</FormGroup>

					<FormGroup  controlId="formCity">
						<ControlLabel>Cidade</ControlLabel>
						<FormControl name="city" type="text" placeholder="Cidade"/>
					</FormGroup>

					<FormGroup  controlId="formState">
						<ControlLabel>Estado</ControlLabel>
						<FormControl name="state" type="text" placeholder="Estado"/>
					</FormGroup>

					<FormGroup  controlId="formNickname">
						<ControlLabel>Nome Fantasia</ControlLabel>
						<FormControl name="nickname" type="text" placeholder="Nome Fantasia"/>
					</FormGroup>

					<FormGroup  controlId="formPhone">
						<ControlLabel>Telefone</ControlLabel>
						<FormControl name="phone" type="number" placeholder="Telefone"/>
					</FormGroup>

					<FormGroup  controlId="formPassword">
						<ControlLabel>Password</ControlLabel>
						<FormControl name="pass" type="password" placeholder="Password"/>
					</FormGroup>

					<FormGroup>
						<Button type="submit" onClick={me.onSubmit} block bsStyle="primary">
							Registrar
						</Button>
					</FormGroup>
				</Form>
			)
		}
	},

	render: function() {
		var me = this;

		return (
			<div style={style.container}>				
				<div className="formWrapper">
					<Tabs activeKey={this.state.fgtype} onSelect={this.handleType} id="user-tabs">
						<Tab eventKey={0} title="Usuários">
							{me.getForm(0)}
						</Tab>
						<Tab eventKey={1} title="Empresas">
							{me.getForm(1)}
						</Tab>
					</Tabs>
				</div>
			</div>
		);
	}

});

module.exports = SignUp;


// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.jsx